@if (loader.isLoading$ | async) {
  <div class="spinner-overlay">
    <div class="mps-spinner" role="progressbar" attr.aria-label="{{ 'loader.aria.spinner' | translate }}"></div>
  </div>
}
